export const Tag = `
  _id
  displayTitle
  position
  name
  slug
  isVisible
  heroMediaUrl
  metafields {
    description
    key
    namespace
    scope
    value
    valueType
  }
`;
